import React, { useState } from 'react'
import UseGetInsideData from '../../hooks/useFetchInsideData';
import CommonImgForm from '../../utils/CommonImgForm';
import ViewFileIndex from '../../components/View/ViewFileIndex';
import CommonCardView from '../../utils/CommonCardView';
import CommonTableView from '../../utils/CommonTableView';

function Helpindex() {
    const [showMyModal, setShowMyModal] = useState(false);
    const handleOnClose = () => setShowMyModal(false);
    const [pageIndex, setPageIndex] = useState(1);
    const [dataCount, setDataCount] = useState(20);
    const [view,setView] = useState(localStorage.getItem('view')||2)
    const {data, totalCount,getData,isLoading} = UseGetInsideData({url:`/help/`,page:pageIndex,pageCount:dataCount})
  
    function listView(){
      localStorage.setItem('view',2);
      setView(2)
    }
    function cardView(){
      localStorage.setItem('view',1);
      setView(1)
    }
  
    let link = "help"
  
    return (
    <ViewFileIndex 
     label='Help'
     menu="User Guide"
     information='This page has the User Guide for MetaSCROLL application. Please refer to the PDF for assistance'
     standardName={"Admin"}
     total={totalCount} 
     setDataCount={setDataCount} 
     dataCount={dataCount} 
     pageIndex={pageIndex} 
     setPageIndex={setPageIndex} 
     view={view} 
     listView={listView} 
     cardView={cardView} 
     setOpenForm={setShowMyModal}
     Access="admin_create"
     >
     {
      view == true? <CommonCardView isLoading={isLoading} data={data} link={link} accessString="admin_delete" fetcher={getData}/> : <CommonTableView accessString="admin_delete" isLoading={isLoading} data={data} fetcher={getData} link={link} />
     }
     <CommonImgForm
       visible={showMyModal}
       onClose={handleOnClose}
       refreshData={getData}
       url={`/help/`}
       appendText='help'
      />
    </ViewFileIndex>
  )
}

export default Helpindex;